module.exports = __webpack_public_path__ + "img/icon_header_advice.e487ee3f.svg";